export default __webpack_public_path__ + "static/media/menu-down.c1277b85.svg";